import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgBoltLarge = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M17 10.35H13.15V1L7 13.65H10.97V23L17 10.35Z"
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SvgBoltLarge.displayName = 'SvgBoltLarge';
const BoltLarge = withForgeIconProps(SvgBoltLarge, {
  name: 'Bolt',
  usage: 'Use to trigger accelerators, like macros and templates.',
  related: 'shortcut, lightning, accelerate',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'large',
});
export default BoltLarge;
